import { render, staticRenderFns } from "./SithMomMaterialDrawingInfoEdit.vue?vue&type=template&id=51b83a80&"
import script from "./SithMomMaterialDrawingInfoEdit.vue?vue&type=script&lang=js&"
export * from "./SithMomMaterialDrawingInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports